type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  /** SVG stroke width in viewBox units; the default is the SVG default (1). */
  strokeWidth?: string;
};
const BackIcon = (props: Props) => {
  const {
    width = '19',
    height = '13',
    viewBox = '0 0 19 13',
    strokeColor = '#F2D093',
    strokeWidth = '1',
  } = props;
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M18 6H0"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 0L0 6L6 12"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BackIcon;
